var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-title',[_vm._v(" Players - in turn order ")]),_vm._l((_vm.playerOrder),function(playerId){return _c('player-row',{key:playerId,attrs:{"player":_vm.players[playerId]}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }